class ProgramacionMenuService {
  constructor() {}
  resources = () => ({
    platos: {
      uri: `/v1/unidadcomedor/plato`,
      method: ['get']
    },
    planillas: {
      uri: `/v1/planillas`,
      method: ['get']
    },
    insertarprogramacion: {
      uri: `/v1/unidadcomedor/insertprogramacioncomedor`,
      method: ['post']
    },
    progcomedor: {
      uri: `/v1/unidadcomedor/progcomedor`,
      method: ['get']
    },
    clientes: {
      uri: `/v1/clientes`,
      method: ['get']
    },
    fechas: {
      uri: `/v1/unidadcomedor/fechas`,
      method: ['get']
    },
    asignarstock: {
      uri: `/v1/unidadcomedor/cambiarstockw`,
      method: ['put']
    },
    sector: {
      uri: `/v1/sectorespadres`,
      method: ['get']
    },
    comedor: {
      uri: `/v1/unidadcomedor/comedorxvotacion`,
      method: ['get']
    },
    dumpprogramacioncomedor: {
      uri: `/v1/unidadcomedor/dumpprogramacioncomedor`,
      method: ['post']
    }
  });
}

export default ProgramacionMenuService;
